import { render, staticRenderFns } from "./AddEditDpe.vue?vue&type=template&id=2610d11d&scoped=true"
import script from "./AddEditDpe.vue?vue&type=script&lang=js"
export * from "./AddEditDpe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610d11d",
  null
  
)

export default component.exports